import { motion } from 'framer-motion'
import React from 'react'
import * as Styles from './LeadScoreChart.module.css'

const LeadScoreChart = ({ leadScore, animateLeadScore, ...props }) => {
  const strokeWidth = 18
  const radius = 50 - strokeWidth / 2

  return (
    <svg viewBox="0 0 100 100" className={Styles.wrapper} {...props}>
      <motion.circle
        cx="50"
        cy="50"
        className={`${Styles.pieChart}`}
        fill="none"
        r={`${radius}`}
        strokeLinecap="round"
        strokeWidth={`${strokeWidth}`}
        pathLength="100"
        strokeDasharray="100px"
        strokeDashoffset={`${100 - animateLeadScore}px`}
      />
    </svg>
  )
}

export default LeadScoreChart
